export const CA_ENVIRONMENT = 'CA_ENVIRONMENT';
